/* @flow */
import * as React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import Copy from 'components/Copy.jsx';
import Dialog from 'components/Dialog.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';

class ParentalConsentSafetyModal extends React.Component<$FlowFixMeProps> {
  render() {
    const { onRequestHide } = this.props;

    return (
      <Dialog
        eventScreenName="ParentalConsentSafetyModal"
        size="small"
        title="Safety policy"
        className="ParentalConsentSafetyModal"
        onRequestHide={onRequestHide}>
        <BoxBody>
          <Copy>
            <p>
              Your child’s teacher is using Remind to share important school updates and
              announcements.
            </p>
            <p>
              As part of the Children’s Online Privacy and Protection Act (“COPPA”), your child
              entered your contact information because they need your permission to use Remind.
            </p>
            <p>
              To provide their communication service, Remind will collect your child’s name, date of
              birth, photograph, email address, and telephone number.
            </p>
            <ol>
              <li>
                <p>
                  Remind <strong>will not</strong> rent or sell this information to anyone.
                </p>
              </li>
              <li>
                <p>
                  Other users will <strong>only</strong> see the name and the photograph.
                </p>
              </li>
              <li>
                <p>
                  For more information about how Remind uses personal information, please see the{' '}
                  <Link href={LinkConstants.PRIVACY_POLICY} target="_blank">
                    Remind Privacy Policy
                  </Link>
                  .
                </p>
              </li>
            </ol>
          </Copy>
        </BoxBody>
      </Dialog>
    );
  }
}
export default ParentalConsentSafetyModal;
